<form [formGroup]="formGroup" id="step6Form">
  <div class="step6-form-container">
    <div class="row">
      @if (controls.rationaleOfTheApplication; as rationaleOfTheApplication) {
        <div class="standard-form-field three-fourth-field rationaleOfTheApplication-field required-field">
          <label
            for="rationaleOfTheApplicationInput"
            [class.invalid]="rationaleOfTheApplication.touched && rationaleOfTheApplication.invalid">
            {{ 'PERSONAL_DATA_FORM.JUSTIFICATION-FOR-THE-APPLICATION.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <textarea
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="10"
              id="rationaleOfTheApplicationInput"
              type="text"
              minLength="1"
              maxLength="9999"
              (keydown)="firstInputKeydown($event)"
              [required]="true"
              [attr.aria-required]="true"
              [attr.aria-invalid]="
                rationaleOfTheApplication.touched && rationaleOfTheApplication.invalid ? 'true' : null
              "
              [attr.aria-describedby]="
                rationaleOfTheApplication.touched && rationaleOfTheApplication.invalid
                  ? 'rationaleOfTheApplicationError'
                  : null
              "
              placeholder=""
              [formControl]="rationaleOfTheApplication"></textarea>
            <!-- ERROR -->
            @if (rationaleOfTheApplication.invalid && rationaleOfTheApplication.touched) {
              <mat-error id="rationaleOfTheApplicationError">
                {{ rationaleOfTheApplication.errors | errorsFormatingAndTranslate }}
              </mat-error>
            }
          </mat-form-field>
        </div>
      }
    </div>
  </div>
</form>
